<script setup lang="ts">
import { Clock } from 'lucide-vue-next'
import type { SearchEntry } from '~/composables/stores/search'

defineProps<{
  items: SearchEntry[]
  selectedIndex: number
}>()

defineEmits<{
  select: [item: SearchEntry, index: number]
  hover: [index: number]
  remove: [item: SearchEntry]
}>()

const t = useTranslator()
</script>

<template>
  <div>
    <div v-if="items.length > 0" class="flex items-center gap-1.5 px-4 py-1.5 mt-1">
      <Clock class="w-3 h-3 text-muted-foreground/40" />
      <span class="text-[0.656rem] font-semibold uppercase tracking-widest text-muted-foreground/40">
        {{ t('SEARCHBAR_LATEST_SEARCHES') }}
      </span>
    </div>

    <SearchResultRow
      v-for="(item, i) in items"
      :key="`recent-${item.type}-${item.search.id}`"
      :data-idx="i"
      :item="item"
      :selected="selectedIndex === i"
      showClearOnHover
      @select="$emit('select', item, i)"
      @hover="$emit('hover', i)"
      @remove="$emit('remove', item)"
    />

    <div v-if="items.length === 0" class="px-4 py-3 text-[0.75rem] text-muted-foreground">
      {{ t('CHROME_SEARCH_NO_RECENT') }}
    </div>
  </div>
</template>
